import { isPlatformServer } from '@angular/common';
import { Storage, StorageConfig } from '@ionic/storage';
import { NoopStorage } from './noop-storage';

export function provideStorage(platformId: object, storageConfig: StorageConfig | undefined): Storage {
  return isPlatformServer(platformId) ? new NoopStorage() : new Storage(storageConfig);
}
